import React from "react";
import { cn } from "../lib/cn";

export const CONSOLE_DOMAIN_TABS = [
  { value: "all", label: "All" },
  { value: "ai", label: "AI" },
  { value: "cortex", label: "Cortex" },
  { value: "task", label: "Tasks" },
  { value: "notification", label: "Notifs" },
  { value: "system", label: "System" },
] as const;

export type ConsoleTab = (typeof CONSOLE_DOMAIN_TABS)[number]["value"];

interface ConsoleTabsProps {
  activeTab: ConsoleTab;
  onTabChange: (tab: ConsoleTab) => void;
  counts?: Partial<Record<ConsoleTab, number>>;
}

export function ConsoleTabs({
  activeTab,
  onTabChange,
  counts,
}: ConsoleTabsProps) {
  return (
    <div
      role="tablist"
      className="flex items-center gap-0.5 px-3 py-1.5 border-b border-border/60 overflow-x-auto scrollbar-none"
    >
      {CONSOLE_DOMAIN_TABS.map((tab) => (
        <button
          key={tab.value}
          role="tab"
          aria-selected={activeTab === tab.value}
          type="button"
          onClick={() => onTabChange(tab.value)}
          className={cn(
            "shrink-0 rounded-md px-2.5 py-1 text-xs font-medium transition-colors whitespace-nowrap",
            activeTab === tab.value
              ? "bg-primary/10 text-primary"
              : "text-muted-foreground hover:text-foreground hover:bg-muted/60",
          )}
        >
          {tab.label}
          {counts?.[tab.value] != null && (
            <span className="ml-1.5 rounded-full bg-muted px-1.5 py-0.5 text-[10px] text-muted-foreground">
              {counts[tab.value]}
            </span>
          )}
        </button>
      ))}
    </div>
  );
}
